import { useCallback, useState } from 'react';

export default function useShowImage() {
    const [showImage, setShowImage] = useState(true);

    const onImageLoad = useCallback(() => {
        setShowImage(true);
    }, []);

    const onImageLoadError = useCallback(() => {
        setShowImage(false);
    }, []);

    return {
        showImage,
        onImageLoad,
        onImageLoadError,
    };
}
